"use client";
import styled from "styled-components";
import Title from "@/components/Title";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Button from "@/components/Button";
import Link from "next/link";
import { useEffect, useState } from "react";
import axios from "axios";
import { text, title } from "@/styles/globalStyleVars";
import HtmlParser from "react-html-parser";

const ContactForm = ({ data }) => {
  const [isSubmitting, setIsSubmitting] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsSubmitting(false);
    }, 300);
  }, []);

  useEffect(() => {
    document.querySelector(".file .dc-btn").addEventListener("click", () => {
      document.querySelector("#file-input").click();
    });
  }, []);

  const { register, handleSubmit, formState, reset } = useForm({ mode: "all" });
  const { errors, isSubmitSuccessful } = formState;

  //--- form submit

  const success = (msg) =>
    toast.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const error = (msg) =>
    toast.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const onSubmit = async (data) => {
    setIsSubmitting(true); // Show spinner
    try {
      const formData = new FormData();
      formData.append("_wpcf7_unit_tag", "form_" + "5522");
      formData.append("your-name", data?.name);
      formData.append("email", data?.email);
      formData.append("phone", data?.phone);
      formData.append("message", data?.message);

      const response = await axios.post(
        "https://cms.ucbstock.com.bd/wp-json/contact-form-7/v1/contact-forms/5522/feedback",
        formData
      );

      if (response.status === 200) {
        success(response?.data?.message);

        reset(); // Reset form fields
      } else {
        error("Failed to submit form. Please try again later.");
      }
    } catch (err) {
      error(
        err?.message
          ? err?.message
          : "Failed to submit form. Please try again later."
      );
    } finally {
      setIsSubmitting(false); // Hide spinner
    }
  };

  const onError = (errors) => {
    // setToastShown(false); // Reset toast shown state on new submission attempt
    const firstError = Object.values(errors)[0];
    error(firstError.message);
  };

  return (
    <StyledContactForm
      className={"horizontal-scroll"}
      data-speed-right={30}
      data-speed-left={-30}
    >
      <Container>
        <Row>
          <Col lg={6}>
            <h4>{data?.post_title}</h4>

            {HtmlParser(data?.job_desc)}

            {/* <h5>Overview</h5>
            <p>
              Sharing opportunities for Creative Business Development Interns to
              join the industry's fastest growing software company.
            </p>

            <ul>
              <h6>Responsibilities</h6>
              <li>Assist sales team with daily activities</li>
              <li>Cold call, cold visit and fix meetings</li>
              <li>
                Preparing presentations, cost proposals, sales reports and other
                documents
              </li>
              <li>
                Attending and participating in meetings, calls, sales and
                business related activities
              </li>
              <li>
                Cultivate strong business relationships with key decision makers
              </li>
            </ul>

            <ul>
              <h6>Work Conditions & Other Benefits</h6>
              <li>Must complete 80+ working days</li>
              <li>Lunch Facilities: Fully Subsidize</li>
              <li>Evening Snacks & Tea/Coffee: Fully Subsidize</li>
              <li>5 Working Days (10am - 07pm),Weekend (Friday & Saturday)</li>
              <li>Full-Time Engagement</li>
            </ul> */}
          </Col>
          <Col lg={6}>
            <Form className={"form"} onSubmit={handleSubmit(onSubmit, onError)}>
              <div className="form-group">
                <Form.Group controlId="formBasicEmail">
                  <Form.Control
                    className={
                      formState?.errors?.name?.message
                        ? "has-error form-control-lg"
                        : "form-control-lg"
                    }
                    {...register("name", {
                      required: "Please enter your full name",
                      pattern: {
                        value: /^[A-Za-z ]+$/,
                        message: "Name must contain only letters",
                      },
                    })}
                    type="text"
                    placeholder="Name*"
                  />
                  {errors.name && (
                    <span className="error-message form-error">
                      {errors.name.message}
                    </span>
                  )}
                </Form.Group>
              </div>
              <div className="phoneEmail">
                <div className="form-group">
                  <Form.Group controlId="formBasicEmail">
                    <Form.Control
                      className={
                        formState?.errors?.email?.message
                          ? "has-error form-control-lg"
                          : "form-control-lg"
                      }
                      {...register("email", {
                        required: {
                          value: true,
                          message: "Please enter a valid email address",
                        },
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Please enter a valid email address",
                        },
                      })}
                      type="email"
                      placeholder="Email*"
                    />
                    {errors.email && (
                      <span className="error-message form-error">
                        {errors.email.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
                <div className="form-group">
                  <Form.Group controlId="formBasicPhone">
                    <Form.Control
                      className={
                        formState?.errors?.phone?.message
                          ? "has-error form-control-lg"
                          : "form-control-lg"
                      }
                      {...register("phone", {
                        required: {
                          value: true,
                          message: "Please enter your phone number",
                        },
                        pattern: {
                          value: /^01[0-9]{9}$/,
                          message: "Please enter a valid 11 digit phone number",
                        },
                      })}
                      type="number"
                      placeholder="Phone Number*"
                    />
                    {errors.phone && (
                      <span className="error-message form-error">
                        {errors.phone.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </div>
              <div className="form-group">
                <Form.Group controlId="formBasicPhone">
                  <Form.Control
                    as="textarea"
                    rows={4}
                    className={
                      formState?.errors?.message?.message
                        ? "has-error form-control-lg"
                        : "form-control-lg"
                    }
                    {...register("message", {
                      required: {
                        value: true,
                        message: "Please enter cover letter",
                      },
                    })}
                    // type="textarea"
                    placeholder="Cover Letter*"
                  />
                  {errors.message && (
                    <span className={"form-error error-message"}>
                      {errors.message?.message}
                    </span>
                  )}
                </Form.Group>
              </div>
              <div className={"form-group button-group"}>
                <div className={"width-fit file"}>
                  <input
                    id={"file-input"}
                    type="file"
                    accept="application/pdf"
                  />
                  <Button src={"javascript:void(0)"} text={"Attach CV"} />
                </div>
                <div
                  className={"width-fit"}
                  onClick={handleSubmit(onSubmit, onError)}
                >
                  <Button src={"javascript:void(0)"} text={"Submit Message"} />
                </div>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </StyledContactForm>
  );
};

const StyledContactForm = styled.section`
  background-color: #fff;
  position: relative;
  .col-lg-6 {
    &:nth-child(even) {
      padding-left: 50px;
    }
    &:nth-child(odd) {
      padding-right: 50px;
    }
  }

  h4 {
    font-family: ${title};
    font-size: 36px !important;
    line-height: 40px !important;
    font-weight: 600 !important;
    margin-bottom: 40px !important;
  }
  p {
    margin-bottom: 20px !important;
  }

  h5 {
    margin-bottom: 20px !important;
    font-weight: 500 !important;
    font-size: 20px !important;
    line-height: 28px;
  }
  p {
    margin-bottom: 40px !important;
  }

  h4,
  p,
  h5 {
    color: ${text} !important;
  }

  .form-group {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .form-control {
      box-shadow: none;
      outline: 0;
      border-radius: 0;
      background: transparent;
      height: auto;
      border-left: none;
      border-right: none;
      border-top: none;
      border-color: rgba(198, 198, 198, 0.5);
      padding: 0 0 8px;
      color: #3c3c3b;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;

      &:focus {
        border-color: #3c3c3b;
      }

      &::placeholder {
        color: #c6c6c6;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    textarea {
      min-height: 80px;
    }
  }

  .phoneEmail {
    display: flex;
    gap: 25px;

    .form-group {
      flex: 0 0 49%;
    }

    @media (max-width: 767px) {
      flex-direction: column;
      gap: 0px;
      .form-group {
        flex: 0 0 100%;

        &:last-child {
          margin-bottom: 30px;
        }
      }
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    margin-bottom: 40px !important;
    h6 {
      font-size: 20px;
      line-height: 28px;
      font-weight: 500;
      margin-bottom: 20px;
    }
    li {
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid rgba(38, 32, 30, 0.2);
      &:nth-last-child(1) {
        border-bottom: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }

      a {
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        color: #191919 !important;
        display: flex;

        svg {
          margin-right: 20px;
          position: relative;
          top: 4px;
        }

        p {
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
          color: #191919 !important;
        }

        &:hover {
          color: #e62e43 !important;

          p {
            color: #e62e43 !important;
          }
        }
      }
    }
  }

  .container {
    margin: 0;
  }

  @media (max-width: 992px) {
    .col-md-4,
    .col-md-8 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  @media (max-width: 767px) {
    padding-bottom: 60px;
    .bg-text-one,
    .bg-text-two {
      display: none;
    }
  }

  form {
    @media (max-width: 767px) {
      margin-bottom: 40px;
    }
  }

  .file {
    position: relative;
    input {
      position: absolute;
      opacity: 0;
    }
  }

  .button-group {
    display: flex;
    .width-fit {
      &:nth-child(1) {
        margin-right: 50px;
      }
    }
  }

  @media (max-width: 991px) {
    .form {
      margin-top: 0px !important;
    }
  }
  @media (max-width: 767px) {
    .button-group {
      flex-wrap: wrap;
      .width-fit {
        min-width: 100%;
        &:nth-child(1) {
          margin-bottom: 40px;
        }
      }
    }
  }
`;

export default ContactForm;
